import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SupportAgentOutlined } from "@mui/icons-material";
import { ReactComponent as FlowSvg } from "../../../assets/logosSvg/LOGOEASYFLOW.svg";
import { ReactComponent as MomSvg } from "../../../assets/logosSvg/LOGOEASYMON.svg";
import { ReactComponent as BiSvg } from "../../../assets/logosSvg/LOGOEASYBI.svg";
import { ReactComponent as ReportSvg } from "../../../assets/logosSvg/easyReport.svg";
import { ReactComponent as MapsSvg } from "../../../assets/logosSvg/LOGOEASYMAPS.svg";
import { ReactComponent as LogSvg } from "../../../assets/logosSvg/logoEasyLog.svg";
import { ReactComponent as ZabbixLogo } from "../../../assets/logosSvg/logoZabbix.svg";
import ProductCard from "./ProductCard";

export default function ProductsSection({ access }) {
  const theme = useTheme();

  const clientLogo = (key) =>
    theme.palette.mode === "dark"
      ? window?.config?.[`REACT_APP_LOGO_${key}_MODE_DARK_URL`] ||
        window?.config?.[`REACT_APP_LOGO_${key}_URL`] ||
        ""
      : window?.config?.[`REACT_APP_LOGO_${key}_URL`] || "";

  const grafanaLink = window?.config?.REACT_APP_GRAFANA_LINK || "";
  const zabbixLink = window?.config?.REACT_APP_ZABBIX_LINK || "";
  const linkEasyBI = grafanaLink?.split("/login") || "";
  const easyBiLink =
    window?.config?.REACT_APP_EASYBI_LINK ||
    `${linkEasyBI?.[0]}/d/HOME_EASYBI` ||
    "";

  const products = [
    {
      key: "suporte",
      name: "Suporte",
      description: "Abra demandas e acompanhe o status dos seus chamados.",
      icon: <SupportAgentOutlined />,
      navigateTo: "/suporte",
      logoHeight: 28,
      accent: "#6C5CE7",
    },
    {
      key: "easyMon",
      name: "EasyMon",
      description: "Monitoramento da sua rede em tempo real.",
      logo: <MomSvg />,
      clientImg: clientLogo("EASY_MON"),
      accent: "#E84B21",
      href: grafanaLink,
      productName: "EasyMon",
      disabled: access ? !access.easyMon : false,
    },
    {
      key: "easyFlow",
      name: "EasyFlow",
      description: "Análise de fluxo e tráfego de dados.",
      logo: <FlowSvg />,
      clientImg: clientLogo("EASY_FLOW"),
      accent: "#25C785",
      href: grafanaLink,
      productName: "EasyFlow",
      disabled: access ? !access.easyFlow : false,
    },
    {
      key: "easyMaps",
      name: "EasyMaps",
      description: "Mapas de rede, topologia e FTTH geolocalizados.",
      logo: <MapsSvg />,
      clientImg: clientLogo("EASY_MAPS"),
      accent: "#E94159",
      navigateTo: "/easyMaps",
      productName: "EasyMaps",
      disabled: access ? !access.easyMaps : false,
    },
    {
      key: "easyReport",
      name: "EasyReport",
      description: "Relatórios automáticos e agendados.",
      logo: <ReportSvg />,
      clientImg: clientLogo("EASY_REPORT"),
      accent: "#F48206",
      navigateTo: "/easyReportV2/relatorios",
      productName: "EasyReport",
      disabled: access ? !access.easyReport : false,
    },
    {
      key: "easyBI",
      name: "EasyBI",
      description: "Dashboards e inteligência de negócio.",
      logo: <BiSvg />,
      clientImg: clientLogo("EASY_BI"),
      accent: "#039FDD",
      href: easyBiLink,
      productName: "EasyBI",
      disabled: access ? !access.easyBI : false,
    },
    {
      key: "easyLog",
      name: "EasyLog",
      description: "Auditoria e insights dos seus logs.",
      logo: <LogSvg />,
      clientImg: clientLogo("EASY_LOGS"),
      accent: theme.palette.easyLog?.primary || "#E11D3D",
      navigateTo: "/easyLog",
      productName: "EasyLog",
      disabled: access ? !access.easyLog : false,
    },
    {
      key: "zabbix",
      name: "Zabbix",
      description: "Acesse o monitoramento Zabbix.",
      logo: <ZabbixLogo />,
      logoHeight: 28,
      accent: "#D40000",
      href: zabbixLink,
    },
  ];

  return (
    <Stack gap={1.5} width="100%">
      <Box>
        <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
          Nossos produtos
        </Typography>
        <Typography
          sx={{ fontSize: "0.85rem", color: theme.palette.text.secondary }}
        >
          Acesse rapidamente cada solução da plataforma.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            xl: "repeat(4, 1fr)",
          },
          gap: 2,
          width: "100%",
        }}
      >
        {products.map((p) => (
          <ProductCard key={p.key} {...p} />
        ))}
      </Box>
    </Stack>
  );
}
